import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Actions } from 'core-components/library/modalDialog'

import { TranslationKeys } from '../../enums/TranslationKeys'

import styles from './PlanLoadingErrorModalContent.module.scss'

interface IProps {
  translations?: { title: string; text: string; close: string }
  onClose: () => void
}

export const PlanLoadingErrorModalContent = ({ onClose, translations }: IProps) => {
  return (
    <div>
      <WidgetHeader>
        <Translation text={translations?.title || TranslationKeys.PlanLoadingErrorModalHeader} />
      </WidgetHeader>
      <div className={styles.text}>
        <Translation text={translations?.text || TranslationKeys.PlanLoadingErrorModalText} />
      </div>
      <Actions
        position={'end'}
        items={[
          {
            id: 'cancel',
            label: translations?.close ? <Translation text={translations.close} /> : 'Cancel',
            onClick: onClose,
            variant: 'text',
            color: 'grey',
          },
        ]}
      />
    </div>
  )
}
